import React, { createContext, useCallback, useContext, useState, ReactNode } from 'react';

interface ChatListContextType {
  isChatListVisible: boolean;
  toggleChatList: () => void;
  showChatList: () => void;
  hideChatList: () => void;
  /** Increments when partners/connections change — UnifiedChatList clears caches and refetches. */
  chatListRefreshKey: number;
  refreshChatList: () => void;
}

const ChatListContext = createContext<ChatListContextType | undefined>(undefined);

export const ChatListProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isChatListVisible, setIsChatListVisible] = useState(false);
  const [chatListRefreshKey, setChatListRefreshKey] = useState(0);

  const refreshChatList = useCallback(() => {
    setChatListRefreshKey((k) => k + 1);
  }, []);

  const toggleChatList = () => {
    setIsChatListVisible((prev) => !prev);
  };

  const showChatList = () => {
    setIsChatListVisible(true);
  };

  const hideChatList = () => {
    setIsChatListVisible(false);
  };

  return (
    <ChatListContext.Provider
      value={{
        isChatListVisible,
        toggleChatList,
        showChatList,
        hideChatList,
        chatListRefreshKey,
        refreshChatList,
      }}
    >
      {children}
    </ChatListContext.Provider>
  );
};

export const useChatList = () => {
  const context = useContext(ChatListContext);
  if (context === undefined) {
    throw new Error('useChatList must be used within a ChatListProvider');
  }
  return context;
};

